




import Vue from "vue";
import Component from "vue-class-component";
import { LGeoJson } from "vue2-leaflet";
import { features } from "@/store";

@Component({
  components: {
    LGeoJson,
  },
})
export default class NavChannelsLayer extends Vue {
  //computed
  get channels() {
    return features.getters.navChannels;
  }
  get styleFunction() {
    return () => {
      return {
        weight: 1,
        color: "blue",
        dashArray: "10, 10",
      };
    };
  }

  //methods
  loadFeatures() {
    if (!this.channels.length) {
      features.dispatch("getChannels");
    }
  }

  created() {
    this.loadFeatures();
  }
}
